<!-- =========================================================================================
    File Name: EmailMailCard.vue
    Description: Email Application - Single Email Card View
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template functional>
  <vx-card class="px-4" :class="data.staticClass">
    <!-- MAIL HEAD -->
    <div class="vx-row">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <!-- Sender Details -->
        <div class="flex items-center">
          <div>
            <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white" :src="props.mailContent.avatar" size="65px" />
          </div>

          <div class="flex flex-col">
            <h5 class="mb-1">{{ props.mailContent.nomPrenom }}</h5>
            <div class="flex items-center">
              <span class="text-sm">{{ props.mailContent.title }}</span>
              
            </div>
          </div>
        </div>
        <!-- /Sender Details -->

        <!-- Mail Time & Date -->
        <div class="flex flex-col justify-end">
          <span class="text-right">{{ props.mailContent.time | time }}</span>
          <div class="flex justify-end mt-2">
            <span class="text-right">{{ props.mailContent.Date }}</span>
          </div>
        </div>
      </div>
      <!-- /Mail Time & Date -->
    </div>

    <!-- MAIL CONTENT -->
    <div class="vx-row">
      <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">
        <div class="mail__content break-words mt-8 mb-4" v-html="props.mailContent.title"></div>
      </div>
    </div>
    
      <div class="vx-row" v-if="props.mailContent.title==='Demande inscrie'">

          

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ props.mailContent.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ props.mailContent.formation }}</p></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Groupe</td>
                <td><vs-select class="selectExample ml-5" v-model="domaine_data"  placeholder="Groupe">
               <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="item,index in props.mailContent.classe" />
            </vs-select></td>
              </tr>
            </table>
            
          </div>
          
          <!-- /Information - Col 2 -->
        </div>
        <div class="vx-row" v-if="props.mailContent.title==='Demande inscrie'">
                                    <div class="vx-col w-full flex justify-between">
                                        <span class="text-lg"></span>
                                        <vs-button class="mt-5 mr-5" color="primary" type="border" @click="ddddd">Accepter</vs-button>
                                    </div>
        </div>
      <div class="vx-row" v-if="props.mailContent.title==='Candidat pas payé'">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ props.mailContent.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ props.mailContent.formation }}</p></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Groupe</td>
                <td><p class="ml-5">Groupe {{ props.mailContent.classe }}</p></td>
              </tr>
            </table>
            
          </div>
          
          <!-- /Information - Col 2 -->
        </div>
        <div class="vx-row" v-if="props.mailContent.title==='Formateur pas été payé'">

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1 mt-6" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Domaine</td>
                <td ><p class="ml-5">{{ props.mailContent.domaine }}</p></td>
              </tr>
              <tr>
                <td class="font-semibold">Formation</td>
                <td ><p class="ml-5">{{ props.mailContent.formation }}</p></td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1  mt-6" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Groupe</td>
                <td><p class="ml-5">Groupe {{ props.mailContent.classe }}</p></td>
              </tr>
            </table>
            
          </div>
          
          <!-- /Information - Col 2 -->
        </div>
  </vx-card>
</template>


<script>
export default {
  props: {
    mailContent: {
      type: Object,
      required: true
    },
   
  },
  data() {
    return {
    }
  },
  computed: {
    
  },
  methods: {
    ddddd(){
      console.log('ddddd')
    }
  },
  components: {
    
  },
  created() {
    console.log('ddddd')
  },
}

</script>
